import script from "./sendMsgManList.vue?vue&type=script&setup=true&lang=js"
export * from "./sendMsgManList.vue?vue&type=script&setup=true&lang=js"

import "./sendMsgManList.vue?vue&type=style&index=0&id=7a60b0e6&lang=css"
import "./sendMsgManList.vue?vue&type=style&index=1&id=7a60b0e6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a60b0e6"]])

export default __exports__